window.meter_management_edit_request_type_2_datetimepicker = function () {
    var instance = {
        init: function () {
            var extraIcon = document.getElementById("metermanagementrequestedit_btnactivationdatetime_dperiodfrom");
            if (extraIcon) {
                extraIcon.remove();
            }
            else {
                setTimeout(() => {
                    extraIcon = document.getElementById("metermanagementrequestedit_btnactivationdatetime_dperiodfrom");
                    if (extraIcon) {
                        extraIcon.remove();
                    }
                }, 0)
            }

            var icon = document.getElementById("metermanagementrequestedit_activationdatetime_btn");
            if (icon) {
                icon.style = "position: relative; order: 1; margin-left: 312px;";
            }
            else {
                setTimeout(() => {
                    icon = document.getElementById("metermanagementrequestedit_activationdatetime_btn");
                    if (icon) {
                        icon.style = "position: relative; order: 1; margin-left: 312px;";;
                    }
                }, 0)
            }

            var timeSelects = document.getElementById("metermanagementrequestedit_activationdatetime_dperiodfromtime");
            if (timeSelects) {
                timeSelects.style = "width: 55px; margin-left: -336.8px; border: none; background-color: #EBF3FF; border-top-right-radius: 15px; border-bottom-right-radius: 15px; "
            }
            else {
                setTimeout(() => {
                    timeSelects = document.getElementById("metermanagementrequestedit_activationdatetime_dperiodfromtime");
                    if (timeSelects) {
                        timeSelects.style = "width: 55px; margin-left: -336.8px; border: none; background-color: #EBF3FF; border-top-right-radius: 15px; border-bottom-right-radius: 15px; "
                    }
                }, 0);
            }

            var hourSelect = document.getElementById("metermanagementrequestedit_activationdatetime_dperiodfromtime_hour");
            if (hourSelect) {
                hourSelect.style = "border: none; background-color: #EBF3FF;";
            }
            else {
                setTimeout(() => {
                    hourSelect = document.getElementById("metermanagementrequestedit_activationdatetime_dperiodfromtime_hour");
                    if (hourSelect) {
                        hourSelect.style = "border: none; background-color: #EBF3FF;";
                    }
                }, 0);
            }

            var minuteSelect = document.getElementById("metermanagementrequestedit_activationdatetime_dperiodfromtime_minute");
            if (minuteSelect) {
                minuteSelect.style = "border: none; background-color: #EBF3FF;";
            }
            else {
                setTimeout(() => {
                    minuteSelect = document.getElementById("metermanagementrequestedit_activationdatetime_dperiodfromtime_minute");
                    if (minuteSelect) {
                        minuteSelect.style = "border: none; background-color: #EBF3FF;";
                    }
                }, 0);
            }
        },
    };
    return instance;
}();